export const pharmaCustomerIdsFromCustomerExclusionList = [
  253214741,
  570898,
  159384275,
  252202915,
  251470622,
  252632458,
  252551058,
  160492399,
  169549480,
  252237164,
  250618211,
  252333103,
  252295401,
  252211451,
  252344458,
  252231397,
  251372652,
  169599951,
  169590214,
  130,
  160387655,
  168986598,
  159405612,
  251670251,
  251332461,
  363076,
  250087885,
  252038768,
  2214,
  251699260,
  252017989,
  11043691,
  251974171,
  251939421,
  160415805,
  251856615,
  251193163,
  251838439,
  251863604,
  169997950,
  251069253,
  244595,
  251856579,
  169942615,
  453130,
  251786515,
  251726178,
  160484045,
  251725080,
  251598245,
  251554314,
  251541556,
  251267201,
  251458252,
  25155114,
  251388067,
  251313331,
  251391564,
  19280,
  162511444,
  250721822,
  4096944,
  11229897,
  251291219,
  251282725,
  250954163,
  251236355,
  251198497,
  251177760,
  251151522,
  251151349,
  251126713,
  14109963,
  251122840,
  251089178,
  251082457,
  251035992,
  11013544,
  251019295,
  250992429,
  250995942,
  250942687,
  250124593,
  250913934,
  250923758,
  262735,
  250854554,
  160410442,
  250192236,
  25147513,
  4082361,
  14442938,
  250232113,
  7007719,
  35218,
  36136503,
  250289005,
  87968,
  557749,
  42136748,
  2022,
  36156328,
  569,
  250235959,
  18106831,
  7590,
  168526602,
  159918918,
  55219,
  5002063,
  160374025,
  162453272,
  16337096,
  42155382,
  160392233,
  169042694,
  25102138,
  14194714,
  250472256,
  168449851,
  250526226,
  160513,
  250552438,
  250578508,
  250547630,
  21,
  304,
  307,
  402,
  556,
  1812,
  10893,
  13946,
  19321,
  27949,
  43224,
  43313,
  48919,
  89789,
  123769,
  129229,
  172766,
  179150,
  211969,
  224397,
  253640,
  267670,
  268037,
  305909,
  313244,
  317191,
  344479,
  345646,
  353130,
  426027,
  459356,
  509817,
  587666,
  593291,
  689208,
  699806,
  809428,
  810439,
  861628,
  2015499,
  2016480,
  2027959,
  2050684,
  2052140,
  2053629,
  2094923,
  2106204,
  3018647,
  4024238,
  4043600,
  4055414,
  4059138,
  4062088,
  4108962,
  5028697,
  5037295,
  5108413,
  5117625,
  6016329,
  7000157,
  7001059,
  7010719,
  7057390,
  7073247,
  7077668,
  11016357,
  11036685,
  11070909,
  11106447,
  11165055,
  11165662,
  11183894,
  11200283,
  11229045,
  11239803,
  11251631,
  11254903,
  11405334,
  11414061,
  11447523,
  12015150,
  12038156,
  12109967,
  12172878,
  12206152,
  12229331,
  12273441,
  12448087,
  13058684,
  13085188,
  13128287,
  13153891,
  13206643,
  13223034,
  13254915,
  13266963,
  13281337,
  13283254,
  13289092,
  13303523,
  13412495,
  13422645,
  14026424,
  14102189,
  14106448,
  14109232,
  14159144,
  14183149,
  14226335,
  14234182,
  14301742,
  14411526,
  15230190,
  15230193,
  15234105,
  15245017,
  15274918,
  15335654,
  18140476,
  18148758,
  18171756,
  19148015,
  19162583,
  19179143,
  19189692,
  21148582,
  25129224,
  25137667,
  25141883,
  25151302,
  25154760,
  25160236,
  25192252,
  25192845,
  36129135,
  36139849,
  36160606,
  42106281,
  42122829,
  42136910,
  42173860,
  50160307,
  50160310,
  158130223,
  158154667,
  158159867,
  159324852,
  159812572,
  159818344,
  159845834,
  159852556,
  159927365,
  160308526,
  160313137,
  160328366,
  160345480,
  160355362,
  160388219,
  160421761,
  162401054,
  162401082,
  162411419,
  162419425,
  162450790,
  162544045,
  162550312,
  162578917,
  163200656,
  163886147,
  168432974,
  168450473,
  168467627,
  168477081,
  168494381,
  168532944,
  169016978,
  169034313,
  250107146,
  250157231,
  250244200,
  250361768,
  250378149,
  105877,
  12197598,
  17201100,
];
